<template>
    <div>
        <div class="demo-upload-list" v-for="(item,index) in uploadList">
            <template v-if="item.status === 'finished'">
                <img :src="item.url?'/api/file/acquisition/'+item.url:item.response.data&&item.response.data.fileMd5?'/api/file/acquisition/'+item.response.data.fileMd5:''">
                <div class="demo-upload-list-cover">
                    <Icon type="ios-eye-outline" @click.native="handleView(index)"></Icon>
                    <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
                </div>
            </template>
            <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
        </div>
        <Upload
            ref="upload"
            :show-upload-list="false"
            :default-file-list="defaultList"
            :on-success="handleSuccess"
            :format="['jpg','jpeg','png']"
            :on-format-error="handleFormatError"
            :before-upload="handleBeforeUpload"
            multiple
            type="drag"
            action="/api/file/fileUpload"
            style="display: inline-block;width:70px;">
            <div style="width: 70px;height:70px;line-height: 70px;">
                <Icon type="ios-camera" size="20"></Icon>
            </div>
        </Upload>
        <Modal title="查看图片" v-model="visible">
            <div class="imgLook">
                <div @click="last" class="lastBtn">
                    <Icon type="ios-arrow-back" />
                </div>
                <img :src="imgUrl" v-if="visible" class="img">
                <div @click="next" class="nextBtn">
                    <Icon type="ios-arrow-forward" />
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    props:['updateData'],
     data () {
            return {
                imgUrl: '',///api/file/acquisition/12d7c98a66221c11bc829012856a7642
                visible: false,
                uploadList: [],
                name:0,
                defaultList:[
                    
                ]
            }
        },
        methods: {
            last(){
                if(this.name>0){
                    this.name--
                    this.imgUrl = this.uploadList[this.name].response.data&&this.uploadList[this.name].response.data.fileMd5? '/api/file/acquisition/'+this.uploadList[this.name].response.data.fileMd5:'';
                }else{
                    this.$Message.info('第一张！')
                }
            },
            next(){
                if(this.name<this.uploadList.length-1){
                    this.name++
                    this.imgUrl = this.uploadList[this.name].response.data&&this.uploadList[this.name].response.data.fileMd5? '/api/file/acquisition/'+this.uploadList[this.name].response.data.fileMd5:'';
                }else{
                    this.$Message.info('最后一张！')
                }
            },
            handleView (name) {
                this.name=name
                this.imgUrl = this.uploadList[this.name].response.data&&this.uploadList[this.name].response.data.fileMd5? '/api/file/acquisition/'+this.uploadList[this.name].response.data.fileMd5:'';
                this.visible = true;
            },
            handleRemove (file) {//文件列表移除文件
                const fileList = this.$refs.upload.fileList;
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
            },
            handleSuccess (res, file, fileList) {//成功回调
                if(res.code==0){
                    this.uploadList = fileList
                }else{
                    this.$Message.info(res.msg)
                    this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
                }
                // debugger
                this.$emit('imgList',fileList)
            },
            handleFormatError (file) {//文件格式验证失败
                this.$Notice.warning({
                    title: '文件格式不正确',
                    desc: '文件 ' + file.name + ' 格式不正确, 请选择jpg、png。'
                });
            },
            handleBeforeUpload(){
                const check = this.uploadList.length < 10;
                if (!check) {
                    this.$Notice.warning({
                        title: '最多上传10张图片'
                    });
                }
                return check;
            }
            // handleMaxSize (file) {
            //     this.$Notice.warning({
            //         title: '文件过大',
            //         desc: '文件  ' + file.name + ' 太大。'
            //     });
            // },
        },
        watch:{
            updateData:{
                handler(newval,oldval){
                    if(JSON.stringify(newval)=='{}'||!newval){
                        this.defaultList=[]
                    }else{
                        let data=JSON.parse(newval)
                        for(let i in data){
                            this.defaultList.push({url:data[i],name:data[i]})
                        }
                    }
                },
                deep:true,
                immediate: true
            }
        },
        mounted () {
            this.uploadList = this.$refs.upload.fileList;
            this.$emit('imgList',this.uploadList)
        }
}
</script>

<style lang="scss" scoped>
    .demo-upload-list{
        display: inline-block;
        width: 70px;
        height: 70px;
        text-align: center;
        line-height: 70px;
        // border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
    .imgLook{
        display: flex;
        justify-content: center;
        align-items: center;
        .img{
            width: 80%;
            height: 80%;
        }
        .lastBtn{
            cursor: pointer;
            font-size: 32px;
        }
        .nextBtn{
            cursor: pointer;
            font-size: 32px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/imageUploade/imageUploade.vue